module.exports = __webpack_public_path__ + "static/media/icon_jiancejishu.9281236a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/page_inspection/icon_jiancejishu.svg
// module id = 558
// module chunks = 0